import React from 'react';

interface ISpinner {
  size: 'sm' | 'md' | 'lg';
  color: 'primary' | 'secondary' | 'accent' | 'dark' | 'transparent';
  className?: string;
}

const spinnerSizes = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

const colorOptions = {
  primary: 'border-hbg-blue',
  secondary: 'border-clayton-blue',
  accent: 'border-white',
  dark: 'border-black-standard',
  transparent: 'border-transparent',
};

export const Spinner = ({ size, color, className }: ISpinner) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`${className} ${spinnerSizes[size]} ${colorOptions[color]} animate-spin rounded-full border-b-2 border-t-2`}
    />
  );
};
